import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { fadeInAnimation } from '../_animations/fade-in.animation';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  animations: [fadeInAnimation]
})
export class HomeComponent {
  public isLoggedIn: boolean;
  private loggedInSubscription: Subscription;

  constructor(
    protected authService: AuthService) {
    this.loggedInSubscription = this.authService.getIsLoggedInMessage().subscribe(
      (isLoggedIn: number) => {
        this.isLoggedIn = (isLoggedIn === 1);
      });
  }

  public ngOnDestroy() {
    if (this.loggedInSubscription) {
      this.loggedInSubscription.unsubscribe();
    }
  }
}
